export const getSpecificString = (content, group) => {
  const cleanedContent = content?.trim();
  if (!group) return '';

  const parts = group.includes(' | ')
    ? group.split(' | ').map(p => p.trim())
    : [group.trim()];

  const position = parts.findIndex(p => p === cleanedContent);

  if (position === -1) {
    return group.trim();
  }

  const subParts = parts.slice(position);
  return subParts.join(' | ');
};

export const replacePipeWithAnd = (el, row) => {
  const str = getSpecificString(el, row);
  return str.replace(/\s*\|\s*/g, ' and ');
};
